var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.setDot()},[_c('div',{staticClass:"step-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"step-body"},[_c('span',{staticClass:"step-body__title"},[_vm._v(" "+_vm._s(_vm.desc)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }